"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _MapPinAlternate = _interopRequireDefault(require("../../Icons/MapPinAlternate"));

var _TouchableOpacity = _interopRequireDefault(require("../../TouchableOpacity"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _useGeocoding = _interopRequireDefault(require("./useGeocoding"));

var _useGeolocation3 = _interopRequireDefault(require("./useGeolocation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1xy3z4t-AutoLocation",
  styles: "transform:translateY(-1px);;label:AutoLocation;"
} : {
  name: "1xy3z4t-AutoLocation",
  styles: "transform:translateY(-1px);;label:AutoLocation;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var AutoLocation = function AutoLocation(props) {
  var _location$position, _location$position2;

  var onSuccess = props.onSuccess,
      onError = props.onError,
      onLoadingStarted = props.onLoadingStarted,
      onLoadingEnded = props.onLoadingEnded,
      _ = props.ref,
      other = (0, _objectWithoutProperties2["default"])(props, ["onSuccess", "onError", "onLoadingStarted", "onLoadingEnded", "ref"]);

  var _useGeolocation = (0, _useGeolocation3["default"])(),
      _useGeolocation2 = (0, _slicedToArray2["default"])(_useGeolocation, 2),
      location = _useGeolocation2[0],
      requestLocation = _useGeolocation2[1];

  var geocoding = (0, _useGeocoding["default"])((_location$position = location.position) === null || _location$position === void 0 ? void 0 : _location$position.lat, (_location$position2 = location.position) === null || _location$position2 === void 0 ? void 0 : _location$position2.lng);
  var t = (0, _useTranslation["default"])();
  var loading = location.loading || geocoding.loading;
  var error = (0, _react.useMemo)(function () {
    if (geocoding.error) {
      return t('could_not_reach_server');
    }

    if (location.error) {
      return location.error.message;
    }
  }, [location.error, geocoding.error]);
  (0, _react.useEffect)(function () {
    if (location.error || geocoding.error) {
      onError === null || onError === void 0 ? void 0 : onError(location.error || geocoding.error);
    }
  }, [location.error, geocoding.error]);
  (0, _react.useEffect)(function () {
    if (geocoding.option) {
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(geocoding.option);
    }
  }, [geocoding.option]);
  (0, _react.useEffect)(function () {
    if (loading) {
      onLoadingStarted === null || onLoadingStarted === void 0 ? void 0 : onLoadingStarted();
      return onLoadingEnded;
    }
  }, [loading]);
  return (0, _core.jsx)(_TouchableOpacity["default"], (0, _extends2["default"])({
    "aria-label": t('geolocate_me'),
    "data-testid": "AutoLocation",
    size: 6,
    type: "button",
    disabled: !!error || loading,
    onClick: requestLocation
  }, other), (0, _core.jsx)(_Icon["default"], {
    "data-testid": "AutoLocationIcon",
    css: _ref,
    as: _MapPinAlternate["default"],
    size: 6,
    color: error ? 'alert' : 'primary'
  }));
};

__signature__(AutoLocation, "useGeolocation{[location, requestLocation]}\nuseGeocoding{geocoding}\nuseTranslation{t}\nuseMemo{error}\nuseEffect{}\nuseEffect{}\nuseEffect{}", function () {
  return [_useGeolocation3["default"], _useGeocoding["default"], _useTranslation["default"]];
});

var _default = AutoLocation;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(AutoLocation, "AutoLocation", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/AutoLocation/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/AutoLocation/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();